var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicateRecipeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 5078"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1999",
    x: 20,
    y: 9,
    width: 32,
    height: 32,
    rx: 5,
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "10 4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1998",
    x: 8,
    y: 20,
    width: 32,
    height: 32,
    rx: 5,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 48",
    d: "M24 27L24 45",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 49",
    d: "M15 36H33",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateRecipeIcon);
export default __webpack_public_path__ + "static/media/duplicateRecipeIcon.189e1c60769f0328ab2f433a5453fe7f.svg";
export { ForwardRef as ReactComponent };